import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import style from "./MUIStyle";
import PropTypes from "prop-types";
import h2Logo from "../../../assets/logo-h2atlas-africa.svg";
import {
	useGetMarkdown,
	useRenderMarkdown,
} from "../../../hooks/Markdown/useMarkdown";

const useStyles = makeStyles(style);

/**
 * An About component that displays information about the GUI and its data sources.
 * @category Native
 * @subcategory About
 * @component
 * @returns {JSX.Element} - The About component UI.
 */
const About = ({ handleCloseAboutDialog, openAboutDialog }) => {
	const classes = useStyles();
	const { content } = useGetMarkdown("about");
	const aboutContent = useRenderMarkdown(content, classes.article);

	return (
		<Dialog
			data-testid="about-panel"
			className={classes.dialogBox}
			open={openAboutDialog}
			onClose={handleCloseAboutDialog}
			maxWidth="lg"
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					padding: "1rem",
				}}
			>
				<img
					id="h2Logo"
					className={classes.h2Logo}
					src={h2Logo}
					alt="h2atlas logo"
				/>
				<Typography variant="body2" color="textSecondary">
					H2Atlas v3.0.0
				</Typography>
			</Box>
			<DialogContent>
        {aboutContent}
				{/* <Intro />
				<Teams />
				<Contact />
				<License />
				<DataSources />
				<References />
				<Acknowledgements />
				<Contributors /> */}
				{/* <PrimaryDataSources /> */}
				{/* <PrimarySoftwareTools /> */}
			</DialogContent>
			<DialogActions>
				<Button
					data-testid="about-OK"
					variant="contained"
					onClick={handleCloseAboutDialog}
					color="primary"
				>
					OK
				</Button>
			</DialogActions>
		</Dialog>
	);
};

About.propTypes = {
	handleCloseAboutDialog: PropTypes.func,
	openAboutDialog: PropTypes.bool,
};

export default About;
